// extracted by mini-css-extract-plugin
export default {"choose-image":"PersonalInformation_choose-image__y95Ta"};